import { render, staticRenderFns } from "./SelectSlide.vue?vue&type=template&id=bdfb2906&scoped=true&lang=pug"
import script from "./SelectSlide.vue?vue&type=script&lang=ts"
export * from "./SelectSlide.vue?vue&type=script&lang=ts"
import style0 from "./SelectSlide.vue?vue&type=style&index=0&id=bdfb2906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfb2906",
  null
  
)

export default component.exports